import WidgetBase from "../common/widgetBase";
import Message from "./../common/message";
import { Converter } from "../../workspace/converter";

export default class MessageNode extends WidgetBase {
  // Where a `file` content block's bytes come from — same guard as message/index.js's fileContext():
  // degrades to undefined instead of throwing when the shellInterface or session double lacks the
  // full seam.
  fileContext() {
    const session = this.context && this.context.session;
    const shellInterface = this.props.data && this.props.data.shellInterface;
    if ( !session || !shellInterface || !shellInterface.getApp || !shellInterface.getRevision ) return undefined;
    const app = shellInterface.getApp();
    const revision = shellInterface.getRevision();
    if ( !app || !app.api || !revision || !revision["id"] ) return undefined;
    return { api: app.api, revisionId: revision["id"], sessionId: session.id };
  }

  renderBody() {
    const [messagesValue, notice] = this.loadObjectValue(
      this.props.data.component, "messages", "messages");
    if ( notice ) return this.renderNotice(notice);

    const messages = (() => {
      let msgs = messagesValue ? messagesValue["messages"] : null;
      if ( msgs ) {
        const maxMessages = Converter.getComponentPortValueData(this.props.data.component, "max_messages");
        if ( maxMessages ) {
          msgs = msgs.slice(0, maxMessages);
        }
      }
      return msgs;
    })();

    if ( !messages ) {
      return this.renderNotice({ variant: "warning", message: "The bound value has no messages to display." });
    }

    const contentView = Converter.getComponentPortValueData(this.props.data.component, "content_view");
    const fileContext = this.fileContext();

    return (
      <>
        {messages.map((messageValue, index) => (
          <Message
            key={index}
            value={messageValue}
            contentView={contentView}
            fileContext={fileContext}
          />
        ))}
      </>
    );
  }
}
